import { Box } from '@mui/material';

import StatusChip from '../chips/StatusChip';
import { MATERIAL_TABLE_TEXTS } from './materialPresentationConstants';
import { formatMaterialArticleLabel } from '../../../utils/formatMaterialArticleLabel';

const CHIP_MAX_WIDTH = 360;

/**
 * Materiales de un documento como chips, igual que las clasificaciones de Finanzas.
 * @param {Object} props
 * @param {Array<Object>} [props.articles] Materiales con `article_name`, cantidad y `unit`.
 * @param {string} [props.quantityKey] Campo de la cantidad (`quantity`, `requested_quantity`).
 * @param {number} [props.maxLabelLength] Máximo de caracteres visibles, incluida la elipsis.
 * @param {Object} [props.chipSx] Estilos de los chips para la vista que los contiene.
 * @returns {JSX.Element}
 */
const MaterialArticleChips = ({
  articles = [],
  quantityKey = 'quantity',
  maxLabelLength,
  chipSx = {},
}) => {
  if (!articles.length) {
    return (
      <StatusChip
        size="small"
        variant="outlined"
        label={MATERIAL_TABLE_TEXTS.noArticles}
        sx={chipSx}
      />
    );
  }

  return (
    <Box
      sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', py: 0.5, maxWidth: { md: 380, lg: 480 } }}
    >
      {articles.map((article, index) => {
        const label = formatMaterialArticleLabel(article, quantityKey);
        return (
          <StatusChip
            key={`${article.article_code}:${index}`}
            size="small"
            label={
              label.length > maxLabelLength ? `${label.slice(0, maxLabelLength - 1)}…` : label
            }
            title={label}
            sx={{ maxWidth: CHIP_MAX_WIDTH, fontWeight: 500, letterSpacing: 0, ...chipSx }}
          />
        );
      })}
    </Box>
  );
};

export default MaterialArticleChips;
